import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const PumpCtx = createContext(null);
const KEY = "pd_pump";
const ROOT_HOSTS = ["petroduty.com", "www.petroduty.com"];

const MULTI = process.env.REACT_APP_MULTI_PUMP === "true";
const DEFAULT_CC = process.env.REACT_APP_DEFAULT_CC;

export function subdomainSlug() {
  const host = window.location.hostname;
  if (!host.endsWith("petroduty.com") || ROOT_HOSTS.includes(host)) return null;
  const label = host.split(".")[0];
  return label && label !== "www" ? label : null;
}

// Single-pump mode: no sub-domain → always the default pump (CC from env). Multi-pump mode is kept for later.
function fixedTarget() {
  const slug = MULTI ? subdomainSlug() : null;
  if (slug) return { slug };
  if (!MULTI && DEFAULT_CC) return { cc: DEFAULT_CC };
  return null;
}

export function applyTheme(theme) {
  const r = document.documentElement.style;
  if (!theme) { ["--bpcl-blue", "--bpcl-blue-dark", "--bpcl-orange", "--bpcl-orange-dark"].forEach((k) => r.removeProperty(k)); return; }
  r.setProperty("--bpcl-blue", theme.primary);
  r.setProperty("--bpcl-blue-dark", theme.primary_dark);
  r.setProperty("--bpcl-orange", theme.accent);
  r.setProperty("--bpcl-orange-dark", theme.accent_dark);
}

export function PumpProvider({ children }) {
  const [pump, setPumpState] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; }
  });
  const [resolving, setResolving] = useState(!!fixedTarget());
  const locked = !!fixedTarget();

  const setPump = (p) => {
    setPumpState(p);
    if (p) localStorage.setItem(KEY, JSON.stringify(p)); else localStorage.removeItem(KEY);
  };

  useEffect(() => {
    const target = fixedTarget();
    if (!target) return;
    api.get("/pumps/resolve", { params: target })
      .then((r) => setPump(r.data))
      .catch(() => setPump(null))
      .finally(() => setResolving(false));
    // eslint-disable-next-line
  }, []);

  useEffect(() => { applyTheme(pump?.theme); }, [pump]);

  return <PumpCtx.Provider value={{ pump, setPump, locked, resolving }}>{children}</PumpCtx.Provider>;
}

export const usePump = () => useContext(PumpCtx);
